import { Card, CardContent, LinearProgress, Typography } from "@mui/material";
import { useSegmentsWithFavourites } from "../../segment/server/use-segments";
import { EmployeeDataGrid } from "./employee-data-grid";

import type { UUID } from "../../../utils/uuid";
import type { EmployeeData } from "../hooks/use-employee-data";
import type { FC } from "react";

export const EmployeeDataGridWrapper: FC<{
  employeeData: EmployeeData;
  type: "hris" | "csv";
}> = ({ employeeData, type }) => {
  const { data: audiences, loading: audiencesLoading } = useSegmentsWithFavourites({
    is_recipient_type: true,
    include_deleted: false,
  });

  if (audiencesLoading) return <LinearProgress />;

  const defaultAudience: UUID | null =
    type === "hris"
      ? (audiences?.find((x) => x.name === "Current employees and upcoming new hires")?.id ??
        audiences?.find((x) => x.name === "Current employees")?.id ??
        null)
      : null;

  return (
    <>
      <Typography variant="h6">View/Download employees</Typography>
      <Typography variant="subtitle2" color="text.secondary">
        View and download a copy of your employee data
      </Typography>
      <Card>
        <CardContent>
          <EmployeeDataGrid
            employeeData={employeeData}
            type={type}
            audiences={audiences ?? []}
            defaultAudience={defaultAudience}
          />
        </CardContent>
      </Card>
    </>
  );
};
